
// react router component layout
import React, { useState } from 'react';

import {
  RouterProvider,
  createBrowserRouter,
  createRoutesFromElements,
  Route,
} from "react-router-dom";

import Layout from "./layouts/Layout";

import Home from "./pages/Home";
import Sale from "./pages/Sale";
import Wypozyczalnia from "./pages/Wypozyczalnia";


import Page404 from "./pages/Page404";
import Error from "./pages/Error";

const router = createBrowserRouter(
  createRoutesFromElements(
    <Route path="/" element={<Layout />} errorElement={<Error />}>
      <Route index element={<Home />} />
			<Route path="sale" element={<Sale />} />
			<Route path="wypozyczalnia" element={<Wypozyczalnia />} />
      <Route path="*" element={<Page404 />} />
    </Route>
  )
);

function App() {
  return <RouterProvider router={router} />;
}

export default App;